import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { DisplayMessage } from '../../../core/messages/display-message';
import { MaintenanceStrategyBoundaryDiagram } from '../../../viewmodels/maintenance-strategies/maintenance-strategy-boundary-diagram';

@Injectable({
  providedIn: 'root',
})
export class BoundaryDiagramService {
  boundaryDiagram = new Subject<MaintenanceStrategyBoundaryDiagram>();
  errorMessages = new Subject<DisplayMessage>();

  constructor() {}
}
